import { Box } from '@mui/material';
import React from 'react';

const TableActionsButtonsWrapper = ({ children }) => (
  <Box
    sx={{
      '& > button:first-child': {
        marginLeft: 0,
      },
    }}
  >
    {children}
  </Box>
);

export default TableActionsButtonsWrapper;
